<section
  class="tw-mx-auto tw-mt-8 tw-flex tw-max-w-[1280px] tw-flex-col tw-items-center tw-gap-4 tw-px-4 md:tw-flex-row md:tw-justify-between md:tw-py-4"
>
  <div class="tw-flex tw-flex-col tw-gap-4">
    <h1
      class="tw-m-0 tw-text-left tw-text-3xl tw-font-bold tw-tracking-wide tw-text-black md:tw-text-4xl"
      [innerHTML]="'shariahPage.heroTitle' | translate"
    ></h1>
    <p class="tw-m-0 tw-max-w-xl tw-text-sm tw-text-black md:tw-text-base">
      {{ 'shariahPage.heroSubtitle' | translate }}
    </p>
    <a
      class="tw-w-fit tw-rounded tw-bg-primary tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-text-white md:tw-text-base"
      [routerLink]="['/equity']"
      [queryParams]="{ sectorIds: 333 }"
      >{{ 'shariahPage.browseOngoingCampaigns' | translate }} &rarr;</a
    >
  </div>
  <img src="/assets/img/hero/shariah-hero.svg" alt="" aria-hidden="true" />
</section>

<section
  class="tw-mx-auto tw-flex tw-max-w-[1280px] tw-flex-col tw-items-center tw-gap-4 tw-px-4 tw-py-12"
>
  <h3 class="tw-font-body tw-text-sm tw-uppercase tw-tracking-wide tw-text-gray-400">
    {{ 'shariahPage.aboutEyebrow' | translate }}
  </h3>
  <h2 class="tw-m-0 tw-text-center tw-text-3xl tw-font-semibold tw-text-blue">
    {{ 'shariahPage.whatIsTitle' | translate }}
  </h2>
  <p class="tw-m-0 tw-text-center tw-text-sm md:tw-text-base">
    {{ 'shariahPage.whatIsSubtitle' | translate }}
  </p>

  <ul
    class="tw-m-0 tw-flex tw-w-full tw-list-none tw-flex-col tw-gap-4 tw-p-0 md:tw-flex-row md:tw-flex-wrap md:tw-justify-center"
  >
    @for (principle of principles; track principle) {
      <li
        class="tw-flex tw-w-full tw-flex-col tw-gap-4 tw-rounded-md tw-border tw-border-gray-400 tw-p-4 md:tw-w-96"
      >
        <img
          [src]="'/assets/img/icons/svgs/' + principle.imgSrc"
          [alt]="principle.title | translate"
          class="tw-w-24"
        />
        <h4 class="tw-font-body tw-text-xl tw-font-semibold">{{ principle.title | translate }}</h4>
        <p class="tw-m-0 tw-text-sm tw-text-black md:tw-text-base">
          {{ principle.description | translate }}
        </p>
        <section class="tw-grid tw-grid-cols-2 tw-gap-2">
          <ul class="tw-m-0 tw-flex tw-list-none tw-flex-col tw-gap-2 tw-p-0">
            @for (positive of principle.positives; track positive) {
              <li class="tw-flex tw-items-start tw-gap-2">
                <img
                  src="/assets/img/icons/svgs/green-tick.svg"
                  [alt]="'shariahPage.iconEncouraged' | translate"
                  class="tw-h-5"
                />
                <p class="tw-m-0 tw-text-sm md:tw-text-base">
                  {{ positive | translate }}
                </p>
              </li>
            }
          </ul>
          <ul class="tw-m-0 tw-flex tw-list-none tw-flex-col tw-gap-2 tw-p-0">
            @for (negative of principle.negatives; track negative) {
              <li class="tw-flex tw-items-start tw-gap-2">
                <img src="/assets/img/icons/svgs/red-cross.svg" [alt]="'shariahPage.iconAvoided' | translate" class="tw-h-6" />
                <p class="tw-m-0 tw-text-sm md:tw-text-base">
                  {{ negative | translate }}
                </p>
              </li>
            }
          </ul>
        </section>
      </li>
    }
  </ul>
</section>

<div class="tw-w-full tw-bg-blue">
  <section class="tw-mx-auto tw-flex tw-max-w-4xl tw-flex-col tw-gap-8 tw-py-12">
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-p-4">
      <h3 class="tw-m-0 tw-font-body tw-text-sm tw-uppercase tw-tracking-wide tw-text-gray-200">
        {{ 'shariahPage.standardsEyebrow' | translate }}
      </h3>
      <h2 class="tw-m-0 tw-text-center tw-text-3xl tw-font-semibold tw-text-white">
        {{ 'shariahPage.whatMakesTitle' | translate }}
      </h2>
      <p class="tw-m-0 tw-text-center tw-text-sm tw-text-white md:tw-text-base">
        {{ 'shariahPage.whatMakesSubtitle' | translate }}
      </p>
    </div>
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-p-4 md:tw-items-start">
      <h2
        class="tw-m-0 tw-mb-2 tw-text-center tw-font-body tw-text-xl tw-font-bold tw-tracking-wide tw-text-white md:tw-text-left md:tw-text-2xl"
      >
        {{ 'shariahPage.businessScreeningTitle' | translate }}
      </h2>
      <p class="tw-m-0 tw-text-center tw-text-sm tw-text-white md:tw-text-left md:tw-text-base">
        {{ 'shariahPage.businessScreeningSubtitle' | translate }}
      </p>

      <article
        class="tw-flex tw-w-full tw-flex-col tw-gap-4 tw-rounded-lg tw-border tw-border-white"
      >
        <div class="tw-divide-y tw-p-4 md:tw-flex md:tw-divide-x md:tw-divide-y-0">
          @for (item of businessScreening; track item) {
            <section class="tw-flex tw-flex-col tw-items-start tw-gap-4 tw-p-4">
              <h5
                class="tw-m-0 tw-font-body tw-text-4xl tw-font-bold tw-text-primary md:tw-text-5xl"
              >
                {{ item.percentage }}
              </h5>
              <p class="tw-m-0 tw-text-sm tw-text-white md:tw-text-base">
                {{ 'shariahPage.applicableToLabel' | translate }}
              </p>
              <ol>
                @for (activity of item.activities; track activity) {
                  <li class="tw-text-white">{{ activity | translate }}</li>
                }
              </ol>
            </section>
          }
        </div>

        <section class="tw-border-t tw-border-t-white tw-p-4">
          <a
            [routerLink]="['/learn/invest/shariah-compliant-equity-crowdfunding-ecf-investors']"
            routerLinkActive="router-link-active"
            class="tw-text-primary"
            >{{ 'shariahPage.readMore' | translate }} &#8594;</a
          >
        </section>
      </article>
    </div>

    <div class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-p-4 md:tw-items-start">
      <h2
        class="tw-m-0 tw-mb-2 tw-text-center tw-font-body tw-text-xl tw-font-bold tw-tracking-wide tw-text-white md:tw-text-left md:tw-text-2xl"
      >
        {{ 'shariahPage.financialRatioTitle' | translate }}
      </h2>
      <p class="tw-m-0 tw-text-center tw-text-sm tw-text-white md:tw-text-left md:tw-text-base">
        {{ 'shariahPage.financialRatioSubtitle' | translate }}
      </p>

      <article
        class="tw-flex tw-w-full tw-flex-col tw-gap-4 tw-rounded-lg tw-border tw-border-white"
      >
        <div class="tw-divide-y tw-p-4 md:tw-flex md:tw-divide-x md:tw-divide-y-0">
          <section class="tw-flex tw-flex-1 tw-items-start tw-gap-4 tw-border-opacity-5 tw-p-4">
            <h5 class="tw-m-0 tw-font-body tw-text-4xl tw-font-bold tw-text-primary md:tw-text-5xl">
              &lt;33%
            </h5>
            <p
              class="tw-m-0 tw-text-sm tw-text-white md:tw-text-xl"
              [innerHTML]="'shariahPage.cashOverAssets' | translate"
            ></p>
          </section>
          <section class="tw-flex tw-flex-1 tw-items-start tw-gap-4 tw-border-opacity-5 tw-p-4">
            <h5 class="tw-m-0 tw-font-body tw-text-4xl tw-font-bold tw-text-primary md:tw-text-5xl">
              &lt;49%
            </h5>
            <p
              class="tw-m-0 tw-text-sm tw-text-white md:tw-text-xl"
              [innerHTML]="'shariahPage.debtOverAssets' | translate"
            ></p>
          </section>
        </div>

        <section class="tw-border-t tw-border-t-white tw-p-4">
          <p class="tw-m-0 tw-text-sm tw-text-white md:tw-text-base">
            {{ 'shariahPage.ratioNote' | translate }}
          </p>
        </section>
      </article>
    </div>
  </section>
</div>

<section
  class="tw-mx-auto tw-flex tw-max-w-[1280px] tw-flex-col tw-items-center tw-gap-4 tw-p-4 tw-py-12"
>
  <h3 class="tw-font-body tw-text-sm tw-uppercase tw-tracking-wide tw-text-gray-400">
    {{ 'shariahPage.whoEyebrow' | translate }}
  </h3>
  <h2 class="tw-m-0 tw-text-center tw-text-3xl tw-font-semibold tw-text-blue">
    {{ 'shariahPage.ethicalTitle' | translate }}
  </h2>

  <ul class="tw-m-0 tw-flex tw-w-full tw-list-none tw-flex-col tw-gap-4 tw-p-0">
    @for (guideline of investmentGuidelines; track guideline) {
      <li
        class="tw-flex tw-w-full tw-flex-col tw-gap-4 tw-rounded-md tw-border tw-border-gray-300 tw-p-4 md:tw-items-center md:tw-gap-8"
        [class]="guideline.isPositive ? 'md:tw-flex-row' : 'md:tw-flex-row-reverse'"
      >
        <div class="tw-flex-1">
          <h4 class="tw-mb-4 tw-font-body tw-text-xl tw-font-semibold">
            {{ guideline.question | translate }}
          </h4>
          <p class="tw-m-0 tw-text-sm tw-text-black md:tw-text-base">
            {{ guideline.description | translate }}
          </p>
        </div>
        <section class="tw-mb-4 tw-mt-8 tw-flex tw-flex-col tw-gap-4 md:tw-mt-4 md:tw-max-w-md">
          <div
            class="tw-flex tw-w-full tw-gap-2 tw-rounded-full tw-border tw-border-gray-300 tw-px-4 tw-py-2"
          >
            <div class="pitchin-icon pitchin-icon-search"></div>
            <p class="tw-m-0 tw-text-sm tw-font-semibold tw-text-black md:tw-text-base">
              {{ guideline.category | translate }}
            </p>
          </div>
          <ul class="tw-m-0 tw-flex tw-list-none tw-flex-wrap tw-gap-2 tw-p-0">
            @for (impact of guideline.impacts; track impact) {
              <li
                class="tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-px-4 tw-py-1"
                [class]="guideline.isPositive ? 'tw-bg-[#13BE5A]' : 'tw-bg-primary'"
              >
                <p
                  class="tw-m-0 tw-text-xs tw-font-medium tw-tracking-wide tw-text-white md:tw-text-base"
                >
                  {{ impact | translate }}
                </p>
                <img
                  [src]="
                    '/assets/img/icons/svgs/' +
                    (guideline.isPositive ? 'white-tick.svg' : 'white-cross.svg')
                  "
                  alt=""
                  aria-hidden="true"
                  class="tw-h-6"
                />
              </li>
            }
          </ul>
        </section>
      </li>
    }
  </ul>
</section>

<div class="tw-w-full tw-bg-[#F6F3F0]">
  <section
    class="tw-mx-auto tw-flex tw-max-w-[1280px] tw-flex-col tw-items-center tw-gap-4 tw-px-4 tw-py-12"
  >
    <h3 class="tw-font-body tw-text-sm tw-uppercase tw-tracking-wide tw-text-gray-400">
      {{ 'shariahPage.forInvestorsEyebrow' | translate }}
    </h3>
    <h2
      class="tw-text-center tw-text-3xl tw-font-semibold tw-text-blue"
      [innerHTML]="'shariahPage.benefitsTitle' | translate"
    ></h2>

    <ul
      class="tw-m-0 tw-flex tw-w-full tw-list-none tw-flex-col tw-gap-4 tw-p-0 md:tw-grid md:tw-grid-cols-2"
    >
      @for (benefit of benefits; track benefit) {
        <li class="gradient-border tw-flex tw-w-full tw-flex-col tw-gap-4 tw-p-4">
          <img
            [src]="'/assets/img/icons/svgs/' + benefit.imgSrc"
            [alt]="benefit.title | translate"
            class="tw-w-24"
          />
          <h4 class="tw-font-body tw-text-xl tw-font-semibold">{{ benefit.title | translate }}</h4>
          <p class="tw-m-0 tw-text-sm tw-text-black md:tw-text-base">
            {{ benefit.description | translate }}
          </p>
        </li>
      }
    </ul>
  </section>
</div>

<section
  class="tw-mx-auto tw-flex tw-max-w-[1280px] tw-flex-col tw-items-center tw-gap-4 tw-px-4 tw-py-12"
>
  <h3 class="tw-font-body tw-text-sm tw-uppercase tw-tracking-wide tw-text-gray-400">
    {{ 'shariahPage.forFoundersEyebrow' | translate }}
  </h3>
  <h2 class="tw-m-0 tw-text-center tw-text-3xl tw-font-semibold tw-text-blue">
    {{ 'shariahPage.whyFundraiseTitle' | translate }}
  </h2>
  @if (role === Role.IssuerRep || role === null) {
    <a
      class="tw-mb-4 tw-mt-8 tw-w-fit tw-rounded tw-border tw-border-primary tw-px-4 tw-py-2 tw-text-base tw-font-semibold tw-text-primary hover:tw-text-primary"
      [routerLink]="handleStartApplication()"
      routerLinkActive="router-link-active"
      >{{ 'shariahPage.startApplication' | translate }} &rarr;</a
    >
  }

  <ul
    class="tw-m-0 tw-flex tw-w-full tw-list-none tw-flex-col tw-gap-4 tw-p-0 md:tw-grid md:tw-grid-cols-2"
  >
    @for (benefit of founderBenefits; track benefit) {
      <li
        class="tw-flex tw-w-full tw-flex-col tw-gap-4 tw-rounded-md tw-border tw-border-gray-400 tw-p-4"
      >
        <img
          [src]="'/assets/img/icons/svgs/' + benefit.imgSrc"
          [alt]="benefit.title | translate"
          class="tw-w-20"
        />
        <h4 class="tw-font-body tw-text-xl tw-font-semibold">{{ benefit.title | translate }}</h4>
        <p class="tw-m-0 tw-text-sm tw-text-black md:tw-text-base">
          {{ benefit.description | translate }}
        </p>
      </li>
    }
  </ul>
</section>

<div class="tw-w-full tw-bg-blue">
  <section
    class="tw-mx-auto tw-flex tw-max-w-[1280px] tw-flex-col tw-items-center tw-gap-4 tw-px-4 tw-py-12 md:tw-flex-row md:tw-justify-between md:tw-py-20"
  >
    <div class="tw-flex tw-max-w-2xl tw-flex-col tw-items-center tw-gap-4 md:tw-items-start">
      <h3 class="tw-font-body tw-text-sm tw-uppercase tw-tracking-wide tw-text-gray-200">
        {{ 'shariahPage.identifyingEyebrow' | translate }}
      </h3>
      <h2 class="tw-m-0 tw-text-center tw-text-3xl tw-font-semibold tw-text-white md:tw-text-left">
        {{ 'shariahPage.howToSpotTitle' | translate }}
      </h2>
      <p
        class="tw-m-0 tw-text-center tw-text-sm tw-text-white md:tw-text-left md:tw-text-base"
        [innerHTML]="'shariahPage.howToSpotSubtitle' | translate"
      ></p>
      <div class="tw-mb-4 tw-mt-8 tw-flex tw-items-center tw-gap-2.5">
        <a
          class="tw-w-fit tw-rounded tw-border tw-border-primary tw-bg-primary tw-px-4 tw-py-2 tw-font-semibold tw-text-white hover:tw-text-white"
          [routerLink]="['/equity']"
          [queryParams]="{ sectorIds: 333 }"
          >{{ 'shariahPage.browseOngoingCampaigns' | translate }} &rarr;</a
        >
        <a
          class="tw-w-fit tw-rounded tw-border tw-border-white tw-px-4 tw-py-2 tw-font-semibold tw-text-white hover:tw-text-white"
          [routerLink]="['/equitysuccess']"
          [queryParams]="{ sectorIds: 333 }"
          >{{ 'shariahPage.viewFundedCampaigns' | translate }} &rarr;</a
        >
      </div>
    </div>

    <img
      src="/assets/img/icons/svgs/shariah-blur-campaign.svg"
      alt=""
      aria-hidden="true"
      class="tw-w-full tw-max-w-md md:tw-hidden"
    />

    <img
      src="/assets/img/icons/svgs/shariah-blur-campaign-desktop.svg"
      alt=""
      aria-hidden="true"
      class="tw-hidden tw-w-80 md:tw-flex"
    />
  </section>
</div>

<section
  class="tw-mx-auto tw-flex tw-max-w-[1280px] tw-flex-col tw-items-center tw-gap-4 tw-px-4 tw-py-12"
>
  <h3 class="tw-font-body tw-text-sm tw-uppercase tw-tracking-wide tw-text-gray-400">
    {{ 'shariahPage.assuranceEyebrow' | translate }}
  </h3>
  <h2
    class="tw-m-0 tw-text-center tw-text-3xl tw-font-semibold tw-text-blue"
    [innerHTML]="'shariahPage.noRoomTitle' | translate"
  ></h2>
  <p class="tw-m-0 tw-max-w-xl tw-text-center tw-text-sm md:tw-mb-8 md:tw-text-base">
    {{ 'shariahPage.assuranceSubtitle' | translate }}
  </p>

  <ul
    class="tw-m-0 tw-flex tw-w-full tw-list-none tw-flex-col tw-gap-2 tw-p-0 md:tw-grid md:tw-grid-cols-3"
  >
    @for (assurance of assurances; track assurance) {
      <li
        class="tw-flex tw-w-full tw-flex-col tw-gap-4 tw-rounded-md tw-border tw-border-gray-400 tw-p-4"
      >
        <img
          [src]="'/assets/img/icons/svgs/' + assurance.imgSrc"
          [alt]="assurance.title | translate"
          class="tw-w-20"
        />
        <h4 class="tw-m-0 tw-font-body tw-text-xl tw-font-semibold">
          {{ assurance.title | translate }}
        </h4>
        <p class="tw-m-0 tw-text-sm tw-text-black md:tw-text-base">
          {{ assurance.description | translate }}
        </p>
      </li>
    }
  </ul>
</section>

<section class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-bg-gray-100 tw-px-4 tw-py-12">
  <h2 class="p-text-h3 tw-mb-8 tw-text-center">{{ 'shariahPage.faqTitle' | translate }}</h2>
  <app-faq-accordion [accordionItems]="pageFaqs" [showTitle]="false" headerClass="tw-bg-white" />
</section>
